import Validation from 'rc-form-validation';

export default Validation;



/** WEBPACK FOOTER **
 ** ./components/validation/index.jsx
 **/